import {FormControl, InputLabel, MenuItem, Select} from "@mui/material"
import React from "react"

export const ProduktSelect = ({id, value, onChangeFunction, produkte, sparteId}) => <FormControl fullWidth>
    <InputLabel id={`${id}ProduktLabel`}>Produkt</InputLabel>
    <Select
        id={id}
        value={value}
        label="Produkt"
        onChange={onChangeFunction}
    >
        {produkte.filter(produkt => produkt?.sparte?.includes(sparteId)).map(produkt => (
            <MenuItem value={produkt}>{produkt.label}</MenuItem>
        ))}
    </Select>
</FormControl>
